export const enum HoldingUserRole {
    Member = 1,
    Owner = 2,
    RestrictedMember = 3
}

export interface ApiAccessPermissions {
    Enabled: boolean
}

export interface ApiReadWritePermissions {
    Read: boolean
    Write: boolean
}

export interface ApiReadWriteFinancialDataAccessPermissions extends ApiReadWritePermissions {
    FinancialData: boolean
}

export interface ApiHoldingUserPermissions {

    Hub: {

        Holdings: ApiReadWritePermissions

        Fields: ApiReadWritePermissions
        MapLayers: ApiReadWritePermissions
        Stocks: ApiReadWriteFinancialDataAccessPermissions
        Soil: ApiReadWritePermissions

        Climate: ApiReadWritePermissions

        SeedPlans: ApiReadWritePermissions
        NutritionPlans: ApiReadWritePermissions
        SprayPlans: ApiReadWritePermissions & {
            HaloAudit: boolean
            EnhancedAudit: boolean
        }

        Manure: ApiReadWritePermissions

        FieldDiary: ApiReadWritePermissions
        TaskManagement: ApiReadWritePermissions

        Exports: ApiAccessPermissions
        Reports: ApiAccessPermissions

        Yield: ApiReadWritePermissions
        Shed: ApiReadWriteFinancialDataAccessPermissions
        Production: ApiReadWritePermissions
        Planning: ApiReadWritePermissions

    },

    Scout: {

        App: ApiAccessPermissions

        Fields: ApiReadWritePermissions
        Records: ApiReadWritePermissions
        Tasks: ApiReadWritePermissions
        Stocks: ApiReadWritePermissions

    }

}

export interface ApiResourceAccessRestrictions {

    Owners: {
        UserId: number
    }[]
}
